/**
 * 灵感词 API 接口
 *
 * @module services/api/inspirationWords
 */

import request from "@/utils/request";

/**
 * 用户行为类型枚举
 */
export enum UserBehaviorType {
  /** 采集 */
  COLLECT = 1,
  /** 点击 */
  CLICK = 2,
  /** 下载 */
  DOWNLOAD = 3,
}

/**
 * 获取灵感推荐词（API 接口）
 *
 * @param fileId 文件ID
 * @param userBehaviorType 用户行为类型（1 采集 2 点击 3下载）
 * @param limit 返回数量（可选，后端会根据 user_behavior_type 返回指定类型的数量）
 * @returns Promise<Array<{ recommend_word: string, ext: {} }>>
 */
export async function getInspirationRecommendWords(
  fileId: string,
  userBehaviorType: UserBehaviorType,
  limit?: number
) {
  return request({
    url: "/search-words/idea-recommend",
    query: {
      file_id: fileId,
      user_behavior_type: userBehaviorType,
      limit: limit || 15,
    },
  });
}
